import { isEmpty } from '@/shared/util';

import {
  convertGoogleDocsMarginIndentLists,
  hasGoogleDocsMarginIndentLists,
} from './google-docs-margin-list-clipboard.util';
import { parseHtmlDocument, serializeNormalizedRoot } from './nested-list-clipboard-dom.util';
import {
  convertWordOfficeListParagraphs,
  hasWordFlatListParagraphs,
} from './word-office-list-clipboard.util';
import {
  convertWordOnlineListItems,
  hasWordOnlineListItems,
} from './word-online-list-clipboard.util';

export { hasGoogleDocsMarginIndentLists } from './google-docs-margin-list-clipboard.util';
export { hasWordFlatListParagraphs } from './word-office-list-clipboard.util';
export { hasWordOnlineListItems } from './word-online-list-clipboard.util';

function isAlreadyQuillFlatList(html: string): boolean {
  const doc = parseHtmlDocument(html);

  return Boolean(doc.querySelector('li[class*="ql-indent-"]'));
}

/**
 * Only the confirmed failing clipboard shapes: Word flat `mso-list` paragraphs,
 * Word Online per-item list containers with `data-aria-level`, and Google Docs
 * sibling lists whose nesting is in margin-left.
 */
export function shouldNormalizeNestedListsForQuill(html: string): boolean {
  if (isEmpty(html)) {
    return false;
  }

  if (isAlreadyQuillFlatList(html)) {
    return false;
  }

  return (
    hasWordFlatListParagraphs(html) ||
    hasWordOnlineListItems(html) ||
    hasGoogleDocsMarginIndentLists(html)
  );
}

function normalizeListsInRoot(root: ParentNode): boolean {
  let didChange = false;

  didChange = convertWordOfficeListParagraphs(root) || didChange;
  didChange = convertWordOnlineListItems(root) || didChange;
  didChange = convertGoogleDocsMarginIndentLists(root) || didChange;

  return didChange;
}

export function normalizeNestedListsForQuillPaste(html: string): string {
  if (!shouldNormalizeNestedListsForQuill(html)) {
    return html;
  }

  const doc = parseHtmlDocument(html);

  if (normalizeListsInRoot(doc.body)) {
    return serializeNormalizedRoot(doc.body);
  }

  // Some clipboard fragments normalize only after reparenting out of <body>.
  const wrapper = doc.createElement('div');

  while (doc.body.firstChild) {
    wrapper.appendChild(doc.body.firstChild);
  }

  if (!normalizeListsInRoot(wrapper)) {
    return html;
  }

  return serializeNormalizedRoot(wrapper);
}
